import { prepararLineasVenta, redondearMoneda } from "./ventas";

export const crearEntradaVenta = ({ estado, clienteId, resumen, resumenPago, operadorId, fecha = new Date() }) => ({
  Operador_Id: Number(operadorId) || 0,
  Cliente_Id: Number(clienteId) || 0,
  ClienteDescripcion:
    estado.Cliente?.sDescripcion ||
    estado.Cliente?.Descripcion ||
    estado.ConsumidorFinalDescripcion ||
    "Consumidor final",
  FormaPago: resumenPago.FormaPago,
  MontoRecibido: redondearMoneda(resumenPago.MontoRecibido),
  Vuelto: redondearMoneda(resumenPago.Vuelto),
  lstPagos: resumenPago.lstPagos,
  Observacion: estado.Observacion || "",
  oResumen: { ...resumen, Total: resumen.TotalConIva },
  lstDetalle: prepararLineasVenta(estado.TicketLineas).map((linea) => {
    const productoNuevo = Boolean(linea.ProductoNuevo || linea.TipoLinea === "Libre");
    return {
      TipoLinea: "Producto",
      Mercaderia_Id: Number(linea.Mercaderia?.Id) || 0,
      Mercaderia_Codigo: linea.Mercaderia?.sCodigo || "",
      Mercaderia_Descripcion: linea.Mercaderia?.sDescripcion || linea.DescripcionManual || "",
      DescripcionManual: linea.DescripcionManual || "",
      VentaSinStock: Boolean(linea.VentaSinStock),
      Cantidad: Number(linea.Cantidad) || 0,
      PrecioUnitario: Number(linea.PrecioUnitario) || 0,
      DescuentoLinea: Number(linea.DescuentoLinea) || 0,
      Subtotal: Number(linea.Subtotal) || 0,
      MercaderiaTipo_Id: Number(linea.Mercaderia?.MercaderiaTipo_Id) ||
        (productoNuevo ? 16 : 0),
      Unidad_Id: Number(linea.Unidad?.Id || linea.Mercaderia?.MercaderiaUnidad_Id || linea.Mercaderia?.UnidadId) || 0,
      Unidad_Descripcion: linea.Unidad?.sDescripcion || linea.Mercaderia?.UnidadDescripcion || linea.Mercaderia?.sUnidad || "",
      Unidad_Codigo: linea.Unidad?.sCodigo || linea.Mercaderia?.UnidadCodigo || "",
      LlevaStock: productoNuevo
        ? true
        : Boolean(linea.Mercaderia?.bLlevaStock),
      CrearCatalogo: productoNuevo,
      CategoriaFiscalId: Number(linea.CategoriaFiscalId ?? linea.CategoriaFiscal?.Id) || 0,
      CategoriaFiscalVersion: Number(linea.CategoriaFiscalVersion ?? linea.CategoriaFiscal?.Version) || 0,
      PrecioFinalUnitario: productoNuevo
        ? Number(linea.PrecioFinalUnitario) || 0
        : 0,
      IvaPendiente: Boolean(linea.IvaPendiente),
      ConSinIVA: Boolean(linea.ConSinIVA),
      PorcentajeIVA: Number(linea.PorcentajeIVA) || 0,
    };
  }),
  dFecha: fecha.toISOString(),
});

export const crearRequestVenta = ({ EmpresaId, cajaSesionId, venta, salida, operadorId, pcId, facturacion }) => ({
  EmpresaId: Number(EmpresaId) || 0,
  cajaSesionId: Number(cajaSesionId) || 0,
  oEntrada: venta,
  oSalida: salida,
  operadorId: Number(operadorId) || 0,
  pcId: Number(pcId) || 0,
  oFacturacion: facturacion,
});

export const crearContenidoComercialVenta = ({ request, politicaFacturacion }) => ({
  OperadorId: request.operadorId,
  PcId: request.pcId,
  EmpresaId: request.EmpresaId,
  ClienteId: request.oEntrada.Cliente_Id,
  FormaPago: request.oEntrada.FormaPago,
  MontoRecibido: request.oEntrada.MontoRecibido,
  Vuelto: request.oEntrada.Vuelto,
  Pagos: request.oEntrada.lstPagos,
  Observacion: request.oEntrada.Observacion,
  Resumen: request.oEntrada.oResumen,
  Detalle: request.oEntrada.lstDetalle,
  PoliticaFacturacion: politicaFacturacion,
  NumeradorId: request.oFacturacion.NumeradorId,
  FormaPagoId: request.oFacturacion.FormaPagoId,
  CuentaCorrienteId: request.oFacturacion.CuentaCorrienteId,
  SolicitaIdentificacionFiscal: request.oFacturacion.SolicitaIdentificacionFiscal,
  FacturarComoConsumidorFinal: request.oFacturacion.FacturarComoConsumidorFinal,
});
